import { atom } from "recoil"

export const inboxContactsRequestIdState = atom({
  key: "atoms/contact/inboxContactsRequestIdState",
  default: 0,
})
